<template>
  <vxe-grid
    ref="xTable"
    resizable
    :data="tableData"
    size="mini"
    :mouse-config="{ area: true }"
    highlight-hover-row
    highlight-current-row
    :height="tableHeight"
    :columns="gridColumns"
    :cell-style="tableCellStyle"
    :row-config="{ height: 60 }"
    :showOverflow="true"
    :tooltip-config="{
      showAll: true,
      theme: 'dark'
    }"
    :keyboard-config="{
      isArrow: true,
      isEnter: true,
      isTab: true,
      isClip: true,
      enterToTab: true,
      isEdit: true
    }"
    :sort-config="{
      trigger: 'cell',
      orders: ['desc', 'asc', null]
    }"
    :seq-config="{
      startIndex: (tablePage.currentPage - 1) * tablePage.pageSize
    }"
    :pager-config="tablePage"
    @page-change="handlePageChange"
    @cell-dblclick="handleDbClick"
  >
  </vxe-grid>
</template>

<script>
import { TEXT_COLOR_MAP } from '@/public/params/global.js'
export default {
  props: {
    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    // 当前激活的tab名
    tabActiveName: {
      type: String,
      default: ''
    },
    // 主界面的查询面板是否显示
    searchFormVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      gridColumns: [],
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 100,
        align: 'right',
        pageSizes: [100, 200, 300, 400, 500],
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      },
      CELL_STYLE_MAP: {
        轻微: {
          color: TEXT_COLOR_MAP.GREY
        },
        一般: {
          color: TEXT_COLOR_MAP.YELLOW
        },
        严重: {
          color: TEXT_COLOR_MAP.RED
        },
        已关闭: {
          color: TEXT_COLOR_MAP.GREY
        }
      }
    }
  },
  created() {
    this.InitColumns()
  },
  methods: {
    // 设置列
    InitColumns() {
      this.gridColumns = [
        { type: 'seq', width: 50, fixed: 'left' },
        {
          title: '创建日期',
          width: 100,
          field: 'createTime',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '标题',
          // width: 300,
          field: 'title',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '产品类型',
          width: 100,
          field: 'productionType',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '模块',
          width: 150,
          field: 'groupName',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '菜单',
          width: 150,
          field: 'vuePath',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '当前指派',
          width: 120,
          field: 'assignedTo',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '问题状态',
          width: 100,
          field: 'status',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '提出人',
          width: 100,
          field: 'openedBy',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        }
      ]
    },
    // 页面函数
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      // this.BindData()
    },
    // 双击查看明细数据
    handleDbClick({ row }) {
      this.$emit('handleDbClick', row)
    },
    tableCellStyle({ row, column }) {
      const prop = column.property
      // 严重程度
      if (prop === 'yanzhongchengdu') {
        return this.CELL_STYLE_MAP[row[prop]]
      } else if (prop === 'zhuangtai') {
        return this.CELL_STYLE_MAP[row[prop]]
      }
      return {}
    },
    // 优先级tag类型，返回值：[success/info/danger]
    colorPriorities(value) {
      if (value === 'I') {
        // 紧急
        return 'danger'
      } else if (value === 'II') {
        // 普通
        return 'warning'
      } else {
        // 不急
        return 'info'
      }
    }
  },
  computed: {
    // 进度表高度
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      let isToolBar = true
      // 正常状态下，需要加上表格距离card上下的margin
      const topBottomMargin = 20

      return this.tableHeightComputed(tableMargin + topBottomMargin, isSearchForm, isToolBar)
    }
  }
}
</script>

<style lang="less" scoped></style>
